import { styled } from '@shared/components';

const ExamCenterSelectionItem = styled('button')(({ as, theme }) => ({
  width: '100%',
  padding: theme.spacing(2.5, 3),
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.grey[50],
  cursor: as === 'div' ? 'default' : 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  border: 'none',
  // NOTE: Disabled state of this button looks like default state but with default cursor
  '&:disabled': {
    cursor: 'default',
    color: theme.palette.text.primary,
  },
}));

export default ExamCenterSelectionItem;
